/**
 * Encore Foundation - 3.8.0
 *
 * The contents of this file is owned and generated by the Global Design Systems team.
 * If you require making changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Global Design Systems
 * encore.spotify.net
 */

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Aquamarine 180
 */
export const aquamarine = '#9bf0e1';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Aubergine 46
 */
export const aubergine = '#503750';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Azure 135
 */
export const azure = '#509bf5';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Bole 123
 */
export const bole = '#c87d55';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Bright Red 100
 */
export const brightRed = '#e61e32';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Chocolate 75
 */
export const chocolate = '#7d4b32';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Citric 186
 */
export const citric = '#cdf564';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Electric Seafoam 167
 */
export const electricSeafoam = '#19e68c';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Factory Yellow 184
 */
export const factoryYellow = '#fae62d';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Forest 75
 */
export const forest = '#006450';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Pink 100
 */
export const fuchsia = '#dc148c';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Gold 155
 */
export const gold = '#f59b23';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Klein Blue 61
 */
export const kleinBlue = '#4100f5';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Lavender 135
 */
export const lavender = '#b49bc8';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Maroon 55
 */
export const maroon = '#8c1932';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Midnight 35
 */
export const midnight = '#1e3264';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Neon Green 176
 */
export const neonGreen = '#5ff550';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Pumpkin 135
 */
export const orange = '#ff6437';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Rose 180
 */
export const pink = '#ffcdd2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Violet Desat 75
 */
export const plum = '#705378';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Powder Green 185
 */
export const powderGreen = '#c3f0c8';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Royal Blue 55
 */
export const royalBlue = '#2d46b9';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Salmon 135
 */
export const salmon = '#f573a0';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Green Blue 100
 */
export const spearmint = '#27856a';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Storm 155
 */
export const storm = '#a0c3d2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Sunflower 172
 */
export const sunflower = '#ffc864';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Tan 135
 */
export const tan = '#c39687';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Red Orange 100
 */
export const tangerine = '#e3230e';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Violet 84
 */
export const violet = '#af2896';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray7 = '#121212';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray10 = '#181818';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray15 = '#282828';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray20 = '#333333';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray30 = '#535353';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray50 = '#7f7f7f';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray70 = '#b3b3b3';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray80 = '#cccccc';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray85 = '#d9d9d9';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray90 = '#eeeeee';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray95 = '#f8f8f8';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack0 = 'rgba(0, 0, 0, 0)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack10 = 'rgba(0, 0, 0, 0.1)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack30 = 'rgba(0, 0, 0, 0.3)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack50 = 'rgba(0, 0, 0, 0.5)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack60 = 'rgba(0, 0, 0, 0.6)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack70 = 'rgba(0, 0, 0, 0.7)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack90 = 'rgba(0, 0, 0, 0.9)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite0 = 'rgba(255, 255, 255, 0)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite10 = 'rgba(255, 255, 255, 0.1)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite30 = 'rgba(255, 255, 255, 0.3)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite50 = 'rgba(255, 255, 255, 0.5)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite60 = 'rgba(255, 255, 255, 0.6)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite70 = 'rgba(255, 255, 255, 0.7)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite90 = 'rgba(255, 255, 255, 0.9)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityBlack0`
 */
export const black0 = 'rgba(0, 0, 0, 0)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityBlack10`
 */
export const black10 = 'rgba(0, 0, 0, 0.1)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityBlack30`
 */
export const black30 = 'rgba(0, 0, 0, 0.3)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityBlack50`
 */
export const black50 = 'rgba(0, 0, 0, 0.5)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityBlack60`
 */
export const black60 = 'rgba(0, 0, 0, 0.6)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityBlack70`
 */
export const black70 = 'rgba(0, 0, 0, 0.7)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityBlack90`
 */
export const black90 = 'rgba(0, 0, 0, 0.9)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityWhite0`
 */
export const white0 = 'rgba(255, 255, 255, 0)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityWhite10`
 */
export const white10 = 'rgba(255, 255, 255, 0.1)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityWhite30`
 */
export const white30 = 'rgba(255, 255, 255, 0.3)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityWhite50`
 */
export const white50 = 'rgba(255, 255, 255, 0.5)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityWhite60`
 */
export const white60 = 'rgba(255, 255, 255, 0.6)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityWhite70`
 */
export const white70 = 'rgba(255, 255, 255, 0.7)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityWhite90`
 */
export const white90 = 'rgba(255, 255, 255, 0.9)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to either `opacityBlack10` or `opacityBlack30`
 */
export const black20 = 'rgba(0, 0, 0, 0.2)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to either `opacityBlack30` or `opacityBlack50`
 */
export const black40 = 'rgba(0, 0, 0, 0.4)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to `opacityWhite10`
 */
export const white5 = 'rgba(255, 255, 255, 0.05)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to either `opacityWhite10` or `opacityWhite30`
 */
export const white20 = 'rgba(255, 255, 255, 0.2)';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to either `opacityWhite30` or `opacityWhite50`
 */
export const white40 = 'rgba(255, 255, 255, 0.4)';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const solidBlack0 = '#000000';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const solidWhite200 = '#ffffff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spotifyBlack7 = '#121212';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const midnight35 = '#202f72';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const aubergine46 = '#503659';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const maroon55 = '#8a202b';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const royalBlue55 = '#283ea3';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const kleinBlue61 = '#4100f4';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const forest75 = '#056952';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const chocolate75 = '#834f34';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet84 = '#b02897';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brightRed100 = '#e91429';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spearmint114 = '#4b917d';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fuchsia115 = '#f036a4';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const tangerine120 = '#ff4834';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bole123 = '#c87d55';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const salmon135 = '#ef77a1';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const lavender135 = '#af93c4';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const azure135 = '#59a0f6';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pumpkin135 = '#ff7439';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const tan135 = '#c19384';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const storm155 = '#a5bbd1';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gold155 = '#ffa42b';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spotifyGreen157 = '#1ed760';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const sunflower172 = '#ffc862';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const rose180 = '#ffd2d7';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const aquamarine180 = '#91eeda';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const factoryYellow184 = '#fce54f';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const powderGreen185 = '#c5f0c9';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const citric186 = '#cff56a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const neonGreen176 = '#5ff550';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const electricSeafoam167 = '#19e68c';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange25 = '#560f00';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange55 = '#911600';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange75 = '#b71800';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange100 = '#e81b00';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange120 = '#ff4834';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange135 = '#ff7163';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange155 = '#ff9e95';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange180 = '#ffd3cf';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown25 = '#3d2418';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown55 = '#683e2a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown75 = '#834f34';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown100 = '#a96440';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown123 = '#c87d55';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown135 = '#d38e67';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown155 = '#e5ac8a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown180 = '#f7d7c3';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat25 = '#3b251d';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat55 = '#653f32';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat75 = '#805040';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat100 = '#a36652';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat135 = '#c19384';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat155 = '#d2b1a6';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat180 = '#eadad5';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange25 = '#4f1800';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange55 = '#862800';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange75 = '#a83200';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange100 = '#d64000';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange135 = '#ff7439';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange155 = '#ffa178';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange180 = '#ffd4c2';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow25 = '#491e00';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow55 = '#793500';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow75 = '#964400';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow100 = '#bc5900';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow135 = '#f47e00';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow155 = '#ffa42b';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow172 = '#ffc862';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow180 = '#ffd97e';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat25 = '#39260e';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat55 = '#624218';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat75 = '#7c531e';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat100 = '#9f6b27';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat135 = '#d0913f';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat155 = '#deb076';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat180 = '#efdabf';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow25 = '#352901';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow55 = '#594602';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow75 = '#705903';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow100 = '#8e7203';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow135 = '#bd9a03';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow155 = '#dab503';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow184 = '#fce54f';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen25 = '#222e03';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen55 = '#3b4f05';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen75 = '#4a6406';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen100 = '#5f8008';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen135 = '#80ac0b';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen155 = '#95c90d';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen186 = '#cff56a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat25 = '#262d11';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat55 = '#414d1e';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat75 = '#526226';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat100 = '#697d30';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat135 = '#8da841';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat155 = '#a9c261';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat180 = '#d7e3b5';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green25 = '#073116';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green55 = '#0c5426';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green75 = '#0f6a2f';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green100 = '#13873c';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green135 = '#19b551';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green157 = '#1ed760';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green180 = '#96f0b6';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat25 = '#182f21';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat55 = '#265135';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat75 = '#2d6740';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat100 = '#34854d';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat135 = '#3db35e';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat155 = '#5cce77';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat185 = '#c5f0c9';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue25 = '#013126';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue55 = '#035341';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue75 = '#056952';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue100 = '#088569';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue135 = '#10b28e';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue155 = '#16d0a6';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue180 = '#91eeda';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat25 = '#182e28';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat55 = '#294f44';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat75 = '#346557';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat100 = '#43816f';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat114 = '#4b917d';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat135 = '#5eac96';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat155 = '#8bc3b3';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat180 = '#c9e3db';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue25 = '#052a56';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue55 = '#084791';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue75 = '#0a59b8';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue100 = '#0d72ea';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue135 = '#59a0f6';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue155 = '#89bcf8';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue180 = '#c8e0fc';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat25 = '#1d2b3a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat55 = '#324b64';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat75 = '#405e7e';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat100 = '#5179a1';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat135 = '#82a1c0';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat155 = '#a5bbd1';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat180 = '#d4dfe9';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet25 = '#26008d';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet55 = '#3c00e4';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet61 = '#4100f4';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet75 = '#5925ff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet100 = '#7358ff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet135 = '#9691ff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet155 = '#afb1ff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet180 = '#d7dbff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat25 = '#1b2658';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat35 = '#202f72';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat55 = '#283ea3';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat75 = '#334fcd';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat100 = '#576dd6';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat135 = '#8a9ae3';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat155 = '#aab6ea';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat180 = '#d7dcf5';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet25 = '#400073';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet55 = '#6900ba';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet75 = '#8400e7';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet100 = '#a833ff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet135 = '#c87dff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet155 = '#d8a3ff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet180 = '#edd4ff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat25 = '#35243a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat46 = '#503659';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat75 = '#734d85';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat100 = '#8e65a9';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat135 = '#af93c4';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat155 = '#c4b1d4';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat180 = '#e3daeb';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink25 = '#4c1141';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink55 = '#801d6d';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink75 = '#a1258a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink84 = '#b02897';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink100 = '#cc2faf';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink135 = '#e079cd';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink155 = '#e9a1dc';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink180 = '#f5d3ef';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat25 = '#3c1c4c';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat55 = '#673081';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat67 = '#773796';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat100 = '#9e57bf';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat135 = '#bb8dd0';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat155 = '#cdaddc';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat180 = '#e7d9ed';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink25 = '#550635';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink55 = '#8d0b58';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink75 = '#b00d6e';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink100 = '#df118b';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink115 = '#f036a4';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink135 = '#f46ebe';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink155 = '#f79bd2';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink180 = '#fcd2eb';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat25 = '#4c172a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat55 = '#871f43';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat75 = '#ad2152';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat100 = '#de2666';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat135 = '#ef77a1';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat155 = '#f1a2bc';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat180 = '#f4d6df';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red25 = '#590810';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red55 = '#930d1a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red75 = '#b81021';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red100 = '#e91429';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red135 = '#f97481';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red155 = '#fe9da7';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red180 = '#ffd2d7';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat25 = '#521319';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat55 = '#8a202b';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat75 = '#ad2836';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat100 = '#d33f4e';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat135 = '#e2828c';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat155 = '#eaa6ad';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat180 = '#f5d6d9';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueFacebook100 = '#2374e1';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentRed109 = '#ff001a';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentOrange144 = '#ff8b1f';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentYellow194 = '#f3ff46';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentGreen176 = '#5ff550';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentGreenBlue167 = '#19e68c';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentCyan185 = '#00ffff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentBlueViolet69 = '#2d28ff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentViolet111 = '#c13fff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentPink119 = '#ff1abf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const green = '#1db954';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const greenLight = '#1ed760';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const greenFocus = '#1da64d';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const greenDark = '#14833b';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const black = '#000000';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const white = '#ffffff';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const red = '#cd1a2b';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const redLight = '#e22134';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const redDark = '#941320';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const blue = '#2e77d0';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const blueLight = '#4687d6';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use blue-facebook-100 instead. This version of the facebook-blue has been subtly tweaked to have accessible contrast with white text. If you need a different shade, please reach out in #encore
 */
export const blueFacebook = '#1877f2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const blueDark = '#1d4c85';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the warning colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const orangeLight = '#ff5722';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicBlackOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Black-3ccff06f351211a5172e0ac43f5a9c24.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicBlackWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Black-a9126697756e0b9bf8d984da997d304c.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiArabicBlackWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Black-16fd768ee89c1a145b9eaadb228ece5a.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicBoldOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Bold-8ff8ce96ad6e69d131f6b6c0a1f497fc.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicBoldWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Bold-45f58735fe46b3f972c5b787e0ca4745.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiArabicBoldWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Bold-aa4c5c76dea408a4e7a673ae5188e8b5.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicBookOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Book-7e5825d4bba33b0a6d6faffcc56644de.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicBookWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Book-d370787b82e945776b4067b43b72e05d.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiArabicBookWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Book-590e30595e03caba45b26307fd28be68.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicLightOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Light-e2b18bb70938188d9becc13ba2f9bff0.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicLightWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Light-48dbb3bbca9655c54bf5e19560bebf48.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiArabicLightWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Light-a37c18e40c5e6ce1f7320b3f6d2f2d19.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicMediumOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Medium-9ece4013263694e5907c37bf8a8c7c78.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiArabicMediumWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Medium-06cb1f024caf0cfc6ba27e6b08924aab.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiArabicMediumWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Arabic-Medium-2d27fcd338ec76d6c75fa63e8da4c005.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicBlackOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Black-cb829684f2647934c93526949a4552a8.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicBlackWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Black-84bb9e740e12139b1a7b1acaa294aa5e.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiCyrillicBlackWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Black-05ec87a84eecb2c7e3df0deedd7e0163.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicBoldOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Bold-234b1726b248573992071f2b1eba10db.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicBoldWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Bold-d3b578139d28c5ab8cef8811a8ec521c.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiCyrillicBoldWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Bold-56e0fc88fd266fe9d5e323df8e190a97.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicBookOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Book-f7dd97ee4149dbf78bb881228cdb2ccf.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicBookWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Book-4458a2f11a26f9778b5c1a1719bf688f.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiCyrillicBookWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Book-a2d035801f91171a95e1da4355607f88.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicLightOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Light-fc71420f38ab14fa81cb02de451f0204.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicLightWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Light-70993f35b6d14a88ebf26bea4c180115.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiCyrillicLightWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Light-212a0377500af34a460b259fcd6d94ac.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicMediumOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Medium-4cc67931d39009a2ccef939c3e7f20cc.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiCyrillicMediumWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Medium-538340d6cee284135f7941bb995208af.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiCyrillicMediumWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Cyrillic-Medium-d3abcd83e2a482a5e88dd3d3a52d301d.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewBlackOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Black-fabbf5a5b1296cc02ca509a8c31596ce.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewBlackWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Black-b79393fd9daf143d284c162732983f79.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiHebrewBlackWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Black-bdc35ee2a02aedc06c6183d9bba64d0d.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewBoldOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Bold-3f3415028614cf4cdf4626787f8c3453.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewBoldWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Bold-0fbb731e50d7a124246e82baf269b51f.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiHebrewBoldWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Bold-66ffc49634f84667dfeeba901fce6e14.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewBookOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Book-8c98900909ee41ddadeda1180e628c15.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewBookWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Book-bc62f5e29c81fe798fd550ce66ec614b.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiHebrewBookWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Book-fdbfe6ba6f193d7002641edd5ba8d1bb.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewLightOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Light-a7aa16b08b44f6318020ef983285d711.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewLightWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Light-5e9af49aa880053957c09ba30694bd2e.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiHebrewLightWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Light-1676f14c6618e747420eb213eba7374b.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewMediumOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Medium-c7c1bee818c76b7812db33ff74deabfa.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiHebrewMediumWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Medium-06d1648a12524a3dcbd823ac64fd5fed.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiHebrewMediumWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Hebrew-Medium-79a7f7bd14a607661fb231e8cc388ce0.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinBlackOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Black-277827f50fd972bef9f803c93a3a45ae.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinBlackWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Black-d11d90541e5f15158097018d3634a9e0.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinBlackWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Black-765ca9bf8d2f11afb11dc49884b779ca.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinBoldOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Bold-f31c1625bddd2b022c98f409dd371297.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinBoldWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Bold-8615f49cf86e86a16ebb9c5565e99743.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinBoldWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Bold-39f75fe74e898cc9ebef1a4e8a6023b5.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinBookOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Book-25062148037cd148fa631a59d0f0ad2e.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinBookWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Book-ac71b98add4c5863080462c2e3252022.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinBookWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Book-ffeb1e7f75131ff615f338c73751b633.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinLightOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Light-45487753dccb48ca8566de4a0013e176.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinLightWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Light-45c42c280e6b5cb0fad09fc449696a35.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinLightWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Light-c0357fd43059d3ecc462a11642334dbb.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinMediumOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Medium-ea05e66e0b9b48192747f1136bb21d1a.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinMediumWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Medium-05ac8305b67ac2c417d97fae9469d064.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinMediumWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-Medium-b662ffed8247440d1e42c93dbe2136cf.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3BlackOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Black-df753a1349d605bc07dfe484043fcbe5.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3BlackWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Black-28e8d44d5fe50c6ad6bf19cfd434a040.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinOs2V3BlackWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Black-c2ff0d2c6b2881a4011115f08c1e8ea8.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3BoldOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Bold-c9c762412fef2ae8768d0a1e4b68d921.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3BoldWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Bold-72388062bd30ced20d5b53e7193dc3b5.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinOs2V3BoldWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Bold-67170478d3578576e2fb314f67cd1f8e.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3BookOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Book-cd2a6d8b588886dfd635273f43451c3c.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3BookWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Book-0a1c466d0e2419d8abc7b5e4f7599bd3.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinOs2V3BookWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Book-343ea4d66e40737dacc56d9bf1f1c2e5.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3LightOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Light-7ebe5e691b442264483a359833ae0ba5.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3LightWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Light-051927242d8f7a17a6e379d639afff29.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinOs2V3LightWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Light-c510659a51047a6b78b17bc518a59465.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3MediumOtf =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Medium-027927d4709fea39d24f3ee12ca23dec.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularSpotifyUiLatinOs2V3MediumWoff =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Medium-98d074d379e7643c066343a9df4a034a.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const circularSpotifyUiLatinOs2V3MediumWoff2 =
  'https://encore.scdn.co/fonts/CircularSpotify-UI-Latin-OS2v3-Medium-aebe60003223426b7a8cd435eab66537.woff2';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularMonoLatinBookOtf =
  'https://encore.scdn.co/fonts/Circular-Mono-Latin-Book-a8ec8c9c5ffc86a9c38db80f8f9fd23b.otf';

/**
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use .woff2 tokens instead, as this fallback isn't needed for the majority of browsers today.
 */
export const circularMonoLatinBookWoff =
  'https://encore.scdn.co/fonts/Circular-Mono-Latin-Book-799d6bf9430113f52f9db2978cc0867c.woff';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * 100% transparency of an element
 */
export const opacity0 = '0';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * 90% transparency of an element
 */
export const opacity10 = '0.1';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * 70% transparency of an element
 */
export const opacity30 = '0.3';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * 50% transparency of an element
 */
export const opacity50 = '0.5';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * 30% transparency of an element
 */
export const opacity70 = '0.7';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 * 10% transparency of an element
 */
export const opacity90 = '0.9';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer4 = '4px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer8 = '8px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer12 = '12px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer16 = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer20 = '20px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer24 = '24px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer32 = '32px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer40 = '40px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer48 = '48px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer56 = '56px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer64 = '64px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer72 = '72px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spacer80 = '80px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladFontSize = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladLineHeight = '24px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladTracking = 'normal';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladWeight = 400;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladBoldFontSize = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladBoldLineHeight = '24px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladBoldTracking = 'normal';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladBoldWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladBoldFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const balladBoldUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaFontSize = '14px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaLineHeight = '20px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaTracking = 'normal';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaWeight = 400;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaBoldFontSize = '14px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaBoldLineHeight = '20px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaBoldTracking = 'normal';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaBoldWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaBoldFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violaBoldUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoFontSize = '14px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoLineHeight = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoTracking = 'normal';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoWeight = 400;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoBoldFontSize = '14px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoBoldLineHeight = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoBoldTracking = 'normal';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoBoldWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoBoldFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const mestoBoldUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassFontSize = '96px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassFontSizeMedium = '72px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassFontSizeSmall = '48px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassLineHeight = '96px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassLineHeightMedium = '72px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassLineHeightSmall = '48px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassTracking = '-0.04em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassWeight = 900;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bassUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const forteFontSize = '72px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const forteLineHeight = '72px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const forteTracking = '-0.04em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const forteWeight = 900;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const forteFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const forteUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brioFontSize = '48px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brioLineHeight = '48px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brioTracking = '-0.04em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brioWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brioFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brioUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const metronomeFontSize = '14px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const metronomeLineHeight = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const metronomeTracking = '0.1em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const metronomeWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const metronomeFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const metronomeUppercase = 'uppercase';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetFontSize = '12px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetLineHeight = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetTracking = '0.1em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetWeight = 400;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetUppercase = 'uppercase';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetBoldFontSize = '12px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetBoldLineHeight = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetBoldTracking = '0.1em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetBoldWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetBoldFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const minuetBoldUppercase = 'uppercase';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleFontSize = '11px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleLineHeight = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleTracking = 'normal';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleWeight = 400;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleBoldFontSize = '11px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleBoldLineHeight = '16px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleBoldTracking = 'normal';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleBoldWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleBoldFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const finaleBoldUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoBrioFontSize = '48px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoBrioLineHeight = '48px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoBrioTracking = '-0.04em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoBrioWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoBrioFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoBrioUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoFontSize = '32px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoLineHeight = '36px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoTracking = '-0.04em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const altoUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const canonFontSize = '24px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const canonLineHeight = '28px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const canonTracking = '-0.04em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const canonWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const canonFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const canonUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloCanonFontSize = '24px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloCanonLineHeight = '28px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloCanonTracking = '-0.04em';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloCanonWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloCanonFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloCanonUppercase = 'none';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloFontSize = '18px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloLineHeight = '24px';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloTracking = 'normal';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloWeight = 700;

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloFont = 'Circular';

/**
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const celloUppercase = 'none';
export const color = {
  aquamarine,
  aubergine,
  azure,
  bole,
  brightRed,
  chocolate,
  citric,
  electricSeafoam,
  factoryYellow,
  forest,
  fuchsia,
  gold,
  kleinBlue,
  lavender,
  maroon,
  midnight,
  neonGreen,
  orange,
  pink,
  plum,
  powderGreen,
  royalBlue,
  salmon,
  spearmint,
  storm,
  sunflower,
  tan,
  tangerine,
  violet,
  gray7,
  gray10,
  gray15,
  gray20,
  gray30,
  gray50,
  gray70,
  gray80,
  gray85,
  gray90,
  gray95,
  opacityBlack0,
  opacityBlack10,
  opacityBlack30,
  opacityBlack50,
  opacityBlack60,
  opacityBlack70,
  opacityBlack90,
  opacityWhite0,
  opacityWhite10,
  opacityWhite30,
  opacityWhite50,
  opacityWhite60,
  opacityWhite70,
  opacityWhite90,
  black0,
  black10,
  black30,
  black50,
  black60,
  black70,
  black90,
  white0,
  white10,
  white30,
  white50,
  white60,
  white70,
  white90,
  black20,
  black40,
  white5,
  white20,
  white40,
  solidBlack0,
  solidWhite200,
  spotifyBlack7,
  midnight35,
  aubergine46,
  maroon55,
  royalBlue55,
  kleinBlue61,
  forest75,
  chocolate75,
  violet84,
  brightRed100,
  spearmint114,
  fuchsia115,
  tangerine120,
  bole123,
  salmon135,
  lavender135,
  azure135,
  pumpkin135,
  tan135,
  storm155,
  gold155,
  spotifyGreen157,
  sunflower172,
  rose180,
  aquamarine180,
  factoryYellow184,
  powderGreen185,
  citric186,
  neonGreen176,
  electricSeafoam167,
  redOrange25,
  redOrange55,
  redOrange75,
  redOrange100,
  redOrange120,
  redOrange135,
  redOrange155,
  redOrange180,
  brown25,
  brown55,
  brown75,
  brown100,
  brown123,
  brown135,
  brown155,
  brown180,
  brownDesat25,
  brownDesat55,
  brownDesat75,
  brownDesat100,
  brownDesat135,
  brownDesat155,
  brownDesat180,
  orange25,
  orange55,
  orange75,
  orange100,
  orange135,
  orange155,
  orange180,
  brownYellow25,
  brownYellow55,
  brownYellow75,
  brownYellow100,
  brownYellow135,
  brownYellow155,
  brownYellow172,
  brownYellow180,
  brownYellowDesat25,
  brownYellowDesat55,
  brownYellowDesat75,
  brownYellowDesat100,
  brownYellowDesat135,
  brownYellowDesat155,
  brownYellowDesat180,
  yellow25,
  yellow55,
  yellow75,
  yellow100,
  yellow135,
  yellow155,
  yellow184,
  yellowGreen25,
  yellowGreen55,
  yellowGreen75,
  yellowGreen100,
  yellowGreen135,
  yellowGreen155,
  yellowGreen186,
  yellowGreenDesat25,
  yellowGreenDesat55,
  yellowGreenDesat75,
  yellowGreenDesat100,
  yellowGreenDesat135,
  yellowGreenDesat155,
  yellowGreenDesat180,
  green25,
  green55,
  green75,
  green100,
  green135,
  green157,
  green180,
  greenDesat25,
  greenDesat55,
  greenDesat75,
  greenDesat100,
  greenDesat135,
  greenDesat155,
  greenDesat185,
  greenBlue25,
  greenBlue55,
  greenBlue75,
  greenBlue100,
  greenBlue135,
  greenBlue155,
  greenBlue180,
  greenBlueDesat25,
  greenBlueDesat55,
  greenBlueDesat75,
  greenBlueDesat100,
  greenBlueDesat114,
  greenBlueDesat135,
  greenBlueDesat155,
  greenBlueDesat180,
  blue25,
  blue55,
  blue75,
  blue100,
  blue135,
  blue155,
  blue180,
  blueDesat25,
  blueDesat55,
  blueDesat75,
  blueDesat100,
  blueDesat135,
  blueDesat155,
  blueDesat180,
  blueViolet25,
  blueViolet55,
  blueViolet61,
  blueViolet75,
  blueViolet100,
  blueViolet135,
  blueViolet155,
  blueViolet180,
  blueVioletDesat25,
  blueVioletDesat35,
  blueVioletDesat55,
  blueVioletDesat75,
  blueVioletDesat100,
  blueVioletDesat135,
  blueVioletDesat155,
  blueVioletDesat180,
  violet25,
  violet55,
  violet75,
  violet100,
  violet135,
  violet155,
  violet180,
  violetDesat25,
  violetDesat46,
  violetDesat75,
  violetDesat100,
  violetDesat135,
  violetDesat155,
  violetDesat180,
  violetPink25,
  violetPink55,
  violetPink75,
  violetPink84,
  violetPink100,
  violetPink135,
  violetPink155,
  violetPink180,
  violetPinkDesat25,
  violetPinkDesat55,
  violetPinkDesat67,
  violetPinkDesat100,
  violetPinkDesat135,
  violetPinkDesat155,
  violetPinkDesat180,
  pink25,
  pink55,
  pink75,
  pink100,
  pink115,
  pink135,
  pink155,
  pink180,
  pinkDesat25,
  pinkDesat55,
  pinkDesat75,
  pinkDesat100,
  pinkDesat135,
  pinkDesat155,
  pinkDesat180,
  red25,
  red55,
  red75,
  red100,
  red135,
  red155,
  red180,
  redDesat25,
  redDesat55,
  redDesat75,
  redDesat100,
  redDesat135,
  redDesat155,
  redDesat180,
  blueFacebook100,
  fluorescentRed109,
  fluorescentOrange144,
  fluorescentYellow194,
  fluorescentGreen176,
  fluorescentGreenBlue167,
  fluorescentCyan185,
  fluorescentBlueViolet69,
  fluorescentViolet111,
  fluorescentPink119,
  green,
  greenLight,
  greenFocus,
  greenDark,
  black,
  white,
  red,
  redLight,
  redDark,
  blue,
  blueLight,
  blueFacebook,
  blueDark,
  orangeLight,
};
export const cdn = {
  circularSpotifyUiArabicBlackOtf,
  circularSpotifyUiArabicBlackWoff,
  circularSpotifyUiArabicBlackWoff2,
  circularSpotifyUiArabicBoldOtf,
  circularSpotifyUiArabicBoldWoff,
  circularSpotifyUiArabicBoldWoff2,
  circularSpotifyUiArabicBookOtf,
  circularSpotifyUiArabicBookWoff,
  circularSpotifyUiArabicBookWoff2,
  circularSpotifyUiArabicLightOtf,
  circularSpotifyUiArabicLightWoff,
  circularSpotifyUiArabicLightWoff2,
  circularSpotifyUiArabicMediumOtf,
  circularSpotifyUiArabicMediumWoff,
  circularSpotifyUiArabicMediumWoff2,
  circularSpotifyUiCyrillicBlackOtf,
  circularSpotifyUiCyrillicBlackWoff,
  circularSpotifyUiCyrillicBlackWoff2,
  circularSpotifyUiCyrillicBoldOtf,
  circularSpotifyUiCyrillicBoldWoff,
  circularSpotifyUiCyrillicBoldWoff2,
  circularSpotifyUiCyrillicBookOtf,
  circularSpotifyUiCyrillicBookWoff,
  circularSpotifyUiCyrillicBookWoff2,
  circularSpotifyUiCyrillicLightOtf,
  circularSpotifyUiCyrillicLightWoff,
  circularSpotifyUiCyrillicLightWoff2,
  circularSpotifyUiCyrillicMediumOtf,
  circularSpotifyUiCyrillicMediumWoff,
  circularSpotifyUiCyrillicMediumWoff2,
  circularSpotifyUiHebrewBlackOtf,
  circularSpotifyUiHebrewBlackWoff,
  circularSpotifyUiHebrewBlackWoff2,
  circularSpotifyUiHebrewBoldOtf,
  circularSpotifyUiHebrewBoldWoff,
  circularSpotifyUiHebrewBoldWoff2,
  circularSpotifyUiHebrewBookOtf,
  circularSpotifyUiHebrewBookWoff,
  circularSpotifyUiHebrewBookWoff2,
  circularSpotifyUiHebrewLightOtf,
  circularSpotifyUiHebrewLightWoff,
  circularSpotifyUiHebrewLightWoff2,
  circularSpotifyUiHebrewMediumOtf,
  circularSpotifyUiHebrewMediumWoff,
  circularSpotifyUiHebrewMediumWoff2,
  circularSpotifyUiLatinBlackOtf,
  circularSpotifyUiLatinBlackWoff,
  circularSpotifyUiLatinBlackWoff2,
  circularSpotifyUiLatinBoldOtf,
  circularSpotifyUiLatinBoldWoff,
  circularSpotifyUiLatinBoldWoff2,
  circularSpotifyUiLatinBookOtf,
  circularSpotifyUiLatinBookWoff,
  circularSpotifyUiLatinBookWoff2,
  circularSpotifyUiLatinLightOtf,
  circularSpotifyUiLatinLightWoff,
  circularSpotifyUiLatinLightWoff2,
  circularSpotifyUiLatinMediumOtf,
  circularSpotifyUiLatinMediumWoff,
  circularSpotifyUiLatinMediumWoff2,
  circularSpotifyUiLatinOs2V3BlackOtf,
  circularSpotifyUiLatinOs2V3BlackWoff,
  circularSpotifyUiLatinOs2V3BlackWoff2,
  circularSpotifyUiLatinOs2V3BoldOtf,
  circularSpotifyUiLatinOs2V3BoldWoff,
  circularSpotifyUiLatinOs2V3BoldWoff2,
  circularSpotifyUiLatinOs2V3BookOtf,
  circularSpotifyUiLatinOs2V3BookWoff,
  circularSpotifyUiLatinOs2V3BookWoff2,
  circularSpotifyUiLatinOs2V3LightOtf,
  circularSpotifyUiLatinOs2V3LightWoff,
  circularSpotifyUiLatinOs2V3LightWoff2,
  circularSpotifyUiLatinOs2V3MediumOtf,
  circularSpotifyUiLatinOs2V3MediumWoff,
  circularSpotifyUiLatinOs2V3MediumWoff2,
  circularMonoLatinBookOtf,
  circularMonoLatinBookWoff,
};
export const opacity = {
  opacity0,
  opacity10,
  opacity30,
  opacity50,
  opacity70,
  opacity90,
};
export const spacer = {
  spacer4,
  spacer8,
  spacer12,
  spacer16,
  spacer20,
  spacer24,
  spacer32,
  spacer40,
  spacer48,
  spacer56,
  spacer64,
  spacer72,
  spacer80,
};
export const type = {
  balladFontSize,
  balladLineHeight,
  balladTracking,
  balladWeight,
  balladFont,
  balladUppercase,
  balladBoldFontSize,
  balladBoldLineHeight,
  balladBoldTracking,
  balladBoldWeight,
  balladBoldFont,
  balladBoldUppercase,
  violaFontSize,
  violaLineHeight,
  violaTracking,
  violaWeight,
  violaFont,
  violaUppercase,
  violaBoldFontSize,
  violaBoldLineHeight,
  violaBoldTracking,
  violaBoldWeight,
  violaBoldFont,
  violaBoldUppercase,
  mestoFontSize,
  mestoLineHeight,
  mestoTracking,
  mestoWeight,
  mestoFont,
  mestoUppercase,
  mestoBoldFontSize,
  mestoBoldLineHeight,
  mestoBoldTracking,
  mestoBoldWeight,
  mestoBoldFont,
  mestoBoldUppercase,
  bassFontSize,
  bassFontSizeMedium,
  bassFontSizeSmall,
  bassLineHeight,
  bassLineHeightMedium,
  bassLineHeightSmall,
  bassTracking,
  bassWeight,
  bassFont,
  bassUppercase,
  forteFontSize,
  forteLineHeight,
  forteTracking,
  forteWeight,
  forteFont,
  forteUppercase,
  brioFontSize,
  brioLineHeight,
  brioTracking,
  brioWeight,
  brioFont,
  brioUppercase,
  metronomeFontSize,
  metronomeLineHeight,
  metronomeTracking,
  metronomeWeight,
  metronomeFont,
  metronomeUppercase,
  minuetFontSize,
  minuetLineHeight,
  minuetTracking,
  minuetWeight,
  minuetFont,
  minuetUppercase,
  minuetBoldFontSize,
  minuetBoldLineHeight,
  minuetBoldTracking,
  minuetBoldWeight,
  minuetBoldFont,
  minuetBoldUppercase,
  finaleFontSize,
  finaleLineHeight,
  finaleTracking,
  finaleWeight,
  finaleFont,
  finaleUppercase,
  finaleBoldFontSize,
  finaleBoldLineHeight,
  finaleBoldTracking,
  finaleBoldWeight,
  finaleBoldFont,
  finaleBoldUppercase,
  altoBrioFontSize,
  altoBrioLineHeight,
  altoBrioTracking,
  altoBrioWeight,
  altoBrioFont,
  altoBrioUppercase,
  altoFontSize,
  altoLineHeight,
  altoTracking,
  altoWeight,
  altoFont,
  altoUppercase,
  canonFontSize,
  canonLineHeight,
  canonTracking,
  canonWeight,
  canonFont,
  canonUppercase,
  celloCanonFontSize,
  celloCanonLineHeight,
  celloCanonTracking,
  celloCanonWeight,
  celloCanonFont,
  celloCanonUppercase,
  celloFontSize,
  celloLineHeight,
  celloTracking,
  celloWeight,
  celloFont,
  celloUppercase,
};
export const ballad = {
  fontSize: '16px',
  lineHeight: '24px',
  textTransform: 'none',
  letterSpacing: 'normal',
  fontWeight: 400,
};
export const balladBold = {
  fontSize: '16px',
  lineHeight: '24px',
  textTransform: 'none',
  letterSpacing: 'normal',
  fontWeight: 700,
};
export const viola = {
  fontSize: '14px',
  lineHeight: '20px',
  textTransform: 'none',
  letterSpacing: 'normal',
  fontWeight: 400,
};
export const violaBold = {
  fontSize: '14px',
  lineHeight: '20px',
  textTransform: 'none',
  letterSpacing: 'normal',
  fontWeight: 700,
};
export const mesto = {
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'none',
  letterSpacing: 'normal',
  fontWeight: 400,
};
export const mestoBold = {
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'none',
  letterSpacing: 'normal',
  fontWeight: 700,
};
export const bass = {
  fontSize: '96px',
  lineHeight: '96px',
  textTransform: 'none',
  letterSpacing: '-0.04em',
  fontWeight: 900,
};
export const forte = {
  fontSize: '72px',
  lineHeight: '72px',
  textTransform: 'none',
  letterSpacing: '-0.04em',
  fontWeight: 900,
};
export const brio = {
  fontSize: '48px',
  lineHeight: '48px',
  textTransform: 'none',
  letterSpacing: '-0.04em',
  fontWeight: 700,
};
export const metronome = {
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  fontWeight: 700,
};
export const minuet = {
  fontSize: '12px',
  lineHeight: '16px',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  fontWeight: 400,
};
export const minuetBold = {
  fontSize: '12px',
  lineHeight: '16px',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  fontWeight: 700,
};
export const finale = {
  fontSize: '11px',
  lineHeight: '16px',
  textTransform: 'none',
  letterSpacing: 'normal',
  fontWeight: 400,
};
export const finaleBold = {
  fontSize: '11px',
  lineHeight: '16px',
  textTransform: 'none',
  letterSpacing: 'normal',
  fontWeight: 700,
};
export const altoBrio = {
  fontSize: '48px',
  lineHeight: '48px',
  textTransform: 'none',
  letterSpacing: '-0.04em',
  fontWeight: 700,
};
export const alto = {
  fontSize: '32px',
  lineHeight: '36px',
  textTransform: 'none',
  letterSpacing: '-0.04em',
  fontWeight: 700,
};
export const canon = {
  fontSize: '24px',
  lineHeight: '28px',
  textTransform: 'none',
  letterSpacing: '-0.04em',
  fontWeight: 700,
};
export const celloCanon = {
  fontSize: '24px',
  lineHeight: '28px',
  textTransform: 'none',
  letterSpacing: '-0.04em',
  fontWeight: 700,
};
export const cello = {
  fontSize: '18px',
  lineHeight: '24px',
  textTransform: 'none',
  letterSpacing: 'normal',
  fontWeight: 700,
};
